/**
 * 드론 경로 분석을 위한 제약사항 설정
 * 각도 범위와 거리 기준값을 중앙에서 관리하여 유지보수성 향상
 */
export const PATH_ANALYSIS_CONFIG = {
  // 각도 범위 정의 (도 단위)
  angles: {
    // 직선 경로 판단 기준
    straight: {
      small: 30,      // 작은 각도 (0~30도): 완전한 직선
      medium: 60,     // 중간 각도 (30~60도): 직선 경로로 판단 가능
      large: 90,      // 큰 각도 (60~90도): 직선 경로로도 판단 가능 (태양광 패널 구간)
    },
    // 90도 회전 판단 기준
    turn90: {
      min: 75,        // 90도 회전 최소 각도
      max: 105,       // 90도 회전 최대 각도
    },
    // 180도 회전 판단 기준
    turn180: {
      min: 165,       // 180도 회전 최소 각도
      max: 195,       // 180도 회전 최대 각도
    },
    // 방향 전환 후 직선 경로 판단 기준
    directionChange: {
      beforeAngleMax: 60,   // beforeAngle 최대값
      nextAngleMin: 120,    // nextAngle 최소값 (방향 전환 완료 후)
      nextAngleMax: 195,    // nextAngle 최대값
    },
  },
  // 거리 기준값
  distance: {
    medianMultiplier: 2,    // median의 배수로 매우 긴 거리 판단
    defaultMedian: 1000,     // 기본 median 값 (cm)
    specialSegmentMultiplier: 1.5,  // 특정 구간의 거리 배수
  },
  // 표준편차 기준
  standardDeviation: {
    threshold: 1,            // distanceFromStdDev 기준값
  },
  // 디버깅용 파일명 목록 (특정 구간 디버깅 시 사용)
  debugFiles: [
    '00153', '00159', '00125', '00132', '00136',
    '00059', '00064', '00051'
  ],
};

/**
 * 각도 범위 체크 헬퍼 함수
 */
export const AngleChecker = {
  /**
   * 작은 각도인지 확인 (직선 경로)
   */
  isSmallAngle(angle) {
    return Math.abs(angle) <= PATH_ANALYSIS_CONFIG.angles.straight.small;
  },
  
  /**
   * 중간 각도인지 확인 (직선 경로 가능)
   */
  isMediumAngle(angle) {
    const abs = Math.abs(angle);
    return abs > PATH_ANALYSIS_CONFIG.angles.straight.small && 
           abs <= PATH_ANALYSIS_CONFIG.angles.straight.medium;
  },
  
  /**
   * 90도 회전인지 확인
   */
  is90DegreeTurn(angle) {
    const abs = Math.abs(angle);
    return abs >= PATH_ANALYSIS_CONFIG.angles.turn90.min && 
           abs <= PATH_ANALYSIS_CONFIG.angles.turn90.max;
  },
  
  /**
   * 180도 회전인지 확인
   */
  is180DegreeTurn(angle) {
    const abs = Math.abs(angle);
    return abs >= PATH_ANALYSIS_CONFIG.angles.turn180.min && 
           abs <= PATH_ANALYSIS_CONFIG.angles.turn180.max;
  },
  
  /**
   * 방향 전환 후 직선 경로인지 확인
   */
  isDirectionChangeToStraight(beforeAngle, nextAngle) {
    const absBefore = Math.abs(beforeAngle);
    const absNext = Math.abs(nextAngle);
    const config = PATH_ANALYSIS_CONFIG.angles.directionChange;
    
    return absBefore <= config.beforeAngleMax &&
           absNext >= config.nextAngleMin &&
           absNext <= config.nextAngleMax;
  },
};

